import { jsx as f } from "react/jsx-runtime";
import { createContext as v, forwardRef as p, useState as I, useRef as x, useImperativeHandle as K, useEffect as N, useContext as O } from "react";
import C from "classnames";
import { useId as S, useTracking as V, IS_ANDROID as H, getText as L } from "../utils.js";
import A from "./tabs.module.less.js";
const $ = v(
  {}
), P = p(function({
  className: n,
  defaultValue: t = 0,
  onChange: e = () => {
  },
  tracking: a = !0,
  value: d,
  ...u
}, y) {
  const [o, D] = I(t), b = typeof d > "u" ? o : d, c = x(null), T = S(), E = V(a), k = (s) => {
    e(s), D(s);
  };
  return K(y, () => c.current), N(() => {
    if (!c.current || !u.children)
      return;
    const s = g(c.current), h = g(c.current, "tabpanel"), R = H ? "data-labelledby" : "aria-labelledby";
    s.forEach((l, i) => {
      const m = h[i] || {}, w = l.id = l.id || `${T}-${i}`;
      m.hidden = i !== b, l.setAttribute("aria-controls", m.id = `${w}-panel`), l.setAttribute("aria-selected", `${i === b}`), l.setAttribute("tabindex", `${i === b ? 0 : -1}`), m instanceof Element && m.setAttribute(R, w);
    }), h.length !== s.length && (h.slice(s.length).forEach((l) => l.hidden = !1), console.warn(
      `Found ${s.length} tabs, but ${h.length} panels - these should be matching in `,
      c.current
    ));
  }, [T, u.children, b]), /* @__PURE__ */ f($.Provider, { value: { ariaId: T, track: E, setValue: k }, children: /* @__PURE__ */ f(
    "div",
    {
      ...u,
      className: C(A.tabs, n),
      ref: c
    }
  ) });
}), G = Object.assign(P, {
  Tablist: p(
    function(n, t) {
      return /* @__PURE__ */ f("div", { ...n, ref: t, role: "tablist" });
    }
  ),
  Tab: p(function({ className: n, tracking: t = !0, ...e }, a) {
    const { setValue: d, track: u } = O($), y = (o) => {
      d(g(o.currentTarget).indexOf(o.currentTarget)), e.onClick && e.onClick(o), t && u({
        eventCategory: "tabs",
        eventAction: "change",
        eventLabel: L(o.currentTarget),
        ...t === !0 ? {} : t
      });
    };
    return /* @__PURE__ */ f(
      "button",
      {
        ...e,
        className: C(A.tab, n),
        onClick: y,
        onKeyDown: (o) => {
          e.onKeyDown && e.onKeyDown(o), _(o);
        },
        ref: a,
        role: "tab",
        type: "button"
      }
    );
  }),
  Panel: p(function(n, t) {
    return /* @__PURE__ */ f("div", { ...n, hidden: !0, ref: t, role: "tabpanel" });
  })
}), j = ["ArrowLeft", "ArrowRight", "Home", "End"], _ = (r) => {
  var a;
  if (!j.includes(r.key))
    return;
  const { key: n, currentTarget: t } = r, e = g(t);
  n === "ArrowLeft" && e[(e.indexOf(t) || e.length) - 1].focus(), n === "ArrowRight" && e[(e.indexOf(t) + 1) % e.length].focus(), n === "Home" && e[0].focus(), n === "End" && ((a = e.pop()) == null || a.focus()), r.preventDefault();
}, g = (r, n = "tab") => {
  const t = `.${A.tabs}`, e = r.closest(t);
  return Array.from(
    (e == null ? void 0 : e.querySelectorAll(`[role="${n}"]`)) || []
  ).filter((a) => a.closest(t) === e);
};
export {
  G as Tabs
};
//# sourceMappingURL=tabs.js.map
